module.exports = __webpack_public_path__ + "media/images/krg-f4a7140a0c772f73458c7cede735b459.jpg";